module.exports = __webpack_public_path__ + "media/images/athletes/1515-1458f8269c27ad633f8411c2f78b17aa.png";